import { UTILS } from "../config/API";

/**
 * Step 1: Request a reset token to be emailed.
 * API: action=forgotpass, form args: email, logonid
 */
export const requestResetToken = async (email, logonId) => {
  try {
    const params = { action: "forgotpass", email, logonid: logonId };
    console.log("API request (forgotpass) URL:", UTILS);
    console.log("API request (forgotpass) params:", params);

    const response = await fetch(UTILS, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      body: new URLSearchParams(params),
    });

    const data = await response.json();
    console.log("API response (forgotpass):", data);

    return {
      success: data.success === true,
      message: data.message || (data.success ? "A reset token has been sent to your email." : "Failed to send reset token."),
    };
  } catch (error) {
    console.error("Request reset token error:", error);
    return { success: false, message: "An error occurred. Please try again." };
  }
};

/**
 * Step 2: Update password using the reset token.
 * API: action=updatepass, form args: rtoken, newpassword, cnewpassword
 */
export const updatePassword = async (rtoken, newPassword, cnewPassword) => {
  try {
    const params = { action: "updatepass", rtoken, newpassword: newPassword, cnewpassword: cnewPassword };
    console.log("API request (updatepass) URL:", UTILS);
    console.log("API request (updatepass) params:", params);

    const response = await fetch(UTILS, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      body: new URLSearchParams(params),
    });

    const data = await response.json();
    console.log("API response (updatepass):", data);

    return {
      success: data.success === true,
      message: data.message || (data.success ? "Your password has been updated." : "Failed to update password."),
    };
  } catch (error) {
    console.error("Update password error:", error);
    return { success: false, message: "An error occurred. Please try again." };
  }
};
